/**
 * Tracking utilities for SPA page views and custom events via dataLayer.
 * Uses dataLayer.push() pattern - GTM will consume the backlog when loaded.
 * 
 * IMPORTANT: Never send PII (email, phone, name) through these events.
 */

// Extend Window interface for dataLayer
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export type TrackingEventParams = Record<string, unknown>;

/**
 * Ensures window.dataLayer is initialized as an array.
 * Safe to call multiple times and before GTM loads.
 */
export function ensureDataLayer(): void {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }
}

/**
 * Pushes an event to the dataLayer with standard page context.
 * GTM will process queued events when it loads.
 * 
 * @param eventName - The event name (e.g., 'page_view', 'button_click')
 * @param params - Additional event parameters (avoid PII)
 */
export function pushEvent(eventName: string, params: TrackingEventParams = {}): void {
  ensureDataLayer();
  
  if (typeof window === 'undefined') return;

  window.dataLayer.push({
    event: eventName,
    ...params,
    page_path: location.pathname + location.search,
    page_location: location.href,
    page_title: document.title,
    ts: Date.now(),
  });
}
